import React from "react";
import { connect } from "react-redux";
import { actions as userActions } from "../../../../../redux/user";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { selectors as userSelectors } from "../../../../../redux/user";
import { t } from "../../../../core/translate";
import { ThemedStyledButton } from "./styles";
import { Signout as SignoutIcon } from "./icons";
import { gaEvent } from "../../../../utils/analytics";

const Signout = ({ currentUser, redirect, show, signout }) =>
  show ? (
    <ThemedStyledButton
      iconStart={<SignoutIcon color="white" />}
      naked
      onClick={event => {
        event.preventDefault();
        gaEvent("header/logout");
        signout(currentUser, redirect);
      }}
    >
      {t("reader.settings.signout", "Sign Out")}
    </ThemedStyledButton>
  ) : null;

const mapStateToProps = state => ({
  currentUser: userSelectors.getUser(state),
  redirect: brandSelectors.getBrandValue(state, "Locations.signout_redirect"),
  show: brandSelectors.getBrandValue(state, "Menu.sign_out")
});

const mapDispatchToProps = dispatch => ({
  signout: (currentUser, redirectTo) =>
    dispatch(userActions.signOut(currentUser, redirectTo))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Signout);
